// @flow
import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router";

import Properties from "../../Properties";
import type { JsonOkResponseType, Json400ResponseType } from "../../global/types/JsonResponseType.js";
import type { ErrorsType, UserFormPropsType, UserFormStatesType } from "../types/UserFormType";
import SingleTextField from "../../global/components/SingleTextField";
import { setErrorMsg, checkEmail, checkPassword, ErrosDisplay } from "../../global/components/ErrosDisplay";
import CompleteMessage from "../../global/components/CompleteMessage";
import { postInit } from "../../global/types/constants";
import { ColorSchema } from "../../global/types/scss";
import { buttonStyles } from "../../global/components/StyledButtons";

import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import Checkbox from "@material-ui/core/Checkbox";
import EmailIcon from "@material-ui/icons/Email";
import { withStyles } from "@material-ui/core/styles";

const DEBOUNCETIME = 500;

class Forgot extends Component<UserFormPropsType, UserFormStatesType> {
  timeout: number;
  constructor(props: UserFormPropsType) {
    super(props);
    this.submit = this.submit.bind(this);
    this.state = {
      conference: props.params.conference || "",
      errors: {},
      loading: false,
      email: "",
      completed: false
    };
  }

  handleChange = (e: Event & { currentTarget: HTMLInputElement }): * => {
    const errors = this.state.errors;
    const name = e.currentTarget.name;
    const value = e.currentTarget.value;
    this.setState({
      [name]: value
    });
    
    clearTimeout(this.timeout);
    this.timeout = setTimeout(function(val: string){ 
      this.setState({ errors: checkEmail(errors, val.trim()) });
    }.bind(this, value), DEBOUNCETIME);
  }

  submit = async (e: Event): * => {
    const errors = this.state.errors;
    e.preventDefault();
    e.stopPropagation();

    if (Object.keys(errors).length === 0) {
      this.setState((): * => ({ "loading": true }));

      const postFormData = new FormData();
      const email = this.state.email.trim();
      postFormData.append("email", email);

      const res: Response = await fetch(`${Properties.api_root}/api/v2/conferences/${this.props.db.conference.id}/requestNewAccessToken`, postInit(postFormData));

      if (res.ok) {
        const jsonResponse: JsonOkResponseType = await res.json();
        this.setState({ completed: true });

      } else if (res.status === 400) {
        const jsonResponse: Json400ResponseType = await res.json();
        this.setState((state: UserFormStatesType): * => ({
          errors: jsonResponse.errors
        }));
      }

      this.setState((): * => ({ "loading": false }));
    }
  }

  render(): React$Element<*> {
    const loading = this.state.loading;
    const errors = this.state.errors;
    const classes = this.props.classes;
    let submitBtn;
    if (loading) {
      submitBtn = <Button color="default" variant="raised" type='submit' id="submitBtn" className="disabled-btn" disabled style={{ width: "auto" }}><CircularProgress size={14} color="inherit" style={{ marginRight: "5px" }} />Sending</Button>;
    }
    else {
      submitBtn = <Button color="primary" variant="raised" type='submit' id="submitBtn" className={classes.primaryBtn} disabled={Object.keys(errors).length > 0} style={{ width: "auto" }}>Send Email</Button>;
    }

    if (this.state.completed) {
      return (
        <Grid container spacing={8}>
          <Grid item xs={1}></Grid>
          <Grid item xs={10}>
            <CompleteMessage
              title="Email Resent"
              content="We have resent you Vertification Email.<br>
              Click on the link included in the Email to<br>
              Access your account and Upload your photos."
            onClick={null}
            />
          </Grid>
        </Grid>
      );
    }
    else {
      return (
        <form onSubmit={(!loading && this.submit) || undefined}>
          <Typography variant="subheading" className="form-text hint-margin-bottom" style={{ color: ColorSchema("primary") }}>
            Please enter your registered email address and we will email your upload link.
          </Typography>
          <Grid container spacing={8}>
            <Grid item xs={1} className="icon-block">
              <EmailIcon className="grey-icon medium-icon" />
            </Grid>
            <Grid item xs={11}>
              <SingleTextField
                isRequired={true}
                label="Email Address"
                name="email"
                value={this.state.email}
                onChange={this.handleChange}
                inpuType="text"
                isInvalid={errors.email !== undefined}
              />
            </Grid>
            <Grid item xs={12}>
              <ErrosDisplay errors={errors} form="signup" />
            </Grid>
            <Grid item xs={12} style={{ marginBottom: "10px" }}>
              <div className="form-right-btn-block">
                <Button color="primary" className={classes.linkBtn + " left-margin-5"} component={Link} to={"/" + this.state.conference + "/signup"}>Back</Button>
                {submitBtn}
              </div>
            </Grid>
          </Grid>
        </form>
      );
    }
  }
}

function mapStateToProps(state) {
  return { db: state.forensic.db };
}

export default connect(mapStateToProps, null)(withStyles(buttonStyles)(Forgot));


// WEBPACK FOOTER //
// ./src/conference/views/Forgot.js